import { render } from "./SocmedAddForm.vue?vue&type=template&id=7e380cca&scoped=true&ts=true"
import script from "./SocmedAddForm.vue?vue&type=script&lang=ts"
export * from "./SocmedAddForm.vue?vue&type=script&lang=ts"

import "./SocmedAddForm.vue?vue&type=style&index=0&id=7e380cca&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e380cca"]])

export default __exports__